import { listClasses, PopoverProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

declare module '@mui/material/Popover' {
  interface PopoverProps {
    padding?: 'normal' | 'none';
  }
}

export default function Popover(theme: Theme) {
  const paperStyles = (ownerState: PopoverProps) => {
    const defaultStyle = {
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.spacing(0.5),
      // boxShadow: 'rgba(0, 0, 0, 0.1) 0px 6px 16px 0px',
      [`& .${listClasses.root}`]: {
        paddingTop: 0,
        paddingBottom: 0,
      },
      ...(ownerState.padding === 'normal' && {
        padding: theme.spacing(0.5),
      }),
      ...(ownerState.padding === 'none' && {
        padding: 0,
      }),
    };

    return defaultStyle;
  };

  return {
    MuiPopover: {
      defaultProps: {
        padding: 'normal',
      },
      styleOverrides: {
        paper: ({ ownerState }: { ownerState: PopoverProps }) =>
          paperStyles(ownerState),
      },
    },
  };
}
